import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './screens/Home';
import Contact from "./screens/Contact";
import BlogList from "./screens/BlogList";
import SingleBlog from "./screens/SingleBlog";
import AboutUs from "./screens/AboutUs";
import Login from "./screens/Login";
import Express from "./screens/Express";
import VipClient from "./screens/VipClient";
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
      {/* <Route index element={<Login/>} /> */}
      <Route  index element={<Home />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/blog" element={<BlogList />} />
          <Route path="/singleBlog" element={<SingleBlog />} />
          <Route path="/about" element={<AboutUs/>} />
          <Route path="/express" element={<Express/>} />
          <Route path="/vipClient" element={<VipClient/>} />

      </Routes>

    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
